import type { IIncomePAYG } from './IncomePAYG.interface';
import { PaymentFrequency } from '../global/PaymentFrequency.enum';

export default class IncomePAYG implements IIncomePAYG {
  grossSalary: number;
  grossSalaryFrequency: PaymentFrequency;
  bonus: number;
  bonusFrequency: PaymentFrequency;
  overtimeEssential: number;
  overtimeEssentialFrequency: PaymentFrequency;
  overtimeNonEssential: number;
  overtimeNonEssentialFrequency: PaymentFrequency;
  commission: number;
  commissionFrequency: PaymentFrequency;
  allowance: number;
  allowanceFrequency: PaymentFrequency;
  foreignIncome: boolean;

  static build = (data: IIncomePAYG) => new IncomePAYG(data);
  static blank = () => new IncomePAYG();

  /**
   * Constructor
   * @param {IIncomePAYG} data
   */
  constructor(data?: IIncomePAYG) {
    this.grossSalary = parseFloat(data?.grossSalary || 0);
    this.grossSalaryFrequency = PaymentFrequency.of(
      data?.grossSalaryFrequency?.name || `f${data?.grossSalaryFrequency}`
    );
    this.bonus = parseFloat(data?.bonus || 0);
    this.bonusFrequency = PaymentFrequency.of(
      data?.bonusFrequency?.name || `f${data?.bonusFrequency}`
    );
    this.overtimeEssential = parseFloat(data?.overtimeEssential || 0);
    this.overtimeEssentialFrequency = PaymentFrequency.of(
      data?.overtimeEssentialFrequency?.name || `f${data?.overtimeEssentialFrequency}`
    );
    this.overtimeNonEssential = parseFloat(data?.overtimeNonEssential || 0);
    this.overtimeNonEssentialFrequency = PaymentFrequency.of(
      data?.overtimeNonEssentialFrequency?.name || `f${data?.overtimeNonEssentialFrequency}`
    );
    this.commission = parseFloat(data?.commission || 0);
    this.commissionFrequency = PaymentFrequency.of(
      data?.commissionFrequency?.name || `f${data?.commissionFrequency}`
    );
    this.allowance = parseFloat(data?.allowance || 0);
    this.allowanceFrequency = PaymentFrequency.of(
      data?.allowanceFrequency?.name || `f${data?.allowanceFrequency}`
    );
    this.foreignIncome = data?.foreignIncome === true;
  }
}
